module.exports = __webpack_public_path__ + "img/ss_green-05.693376b9.jpg";